import React, { Component } from "react";
import { Row, Col } from "shards-react";
import { Table, Input, Button, Space } from "antd";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import categoryService from "../../../../api/Category/CategoryService";
export default class PreviewAllCategories extends Component {
  constructor(props) {
    super(props);

    this.state = { categoryList: [] };

    this.handleEvent = this.handleEvent.bind(this);
  }

  componentDidMount() {
    this.getCategoryList();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.name !== this.state.name) {
      this.handler();
    }
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  componentWillUnmount() {}

  // Prototype methods, Bind in Constructor (ES2015)
  handleEvent() {}

  // Class Properties (Stage 3 Proposal)
  handler = () => {
    this.setState();
  };

  getCategoryList = () => {
    let categoryList = this.state.categoryList;
    categoryService
      .getAllCategories()
      .then((res) => {
        categoryList = res.data;
        this.setState({ categoryList });
      })
      .catch((err) => {
        toast.error(err.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      });
  };
  onButtonClick = (id) => {
    categoryService.deleteCategory(id);
    toast.success(`Category Deleted Successfully`, {
      position: toast.POSITION.TOP_CENTER,
    });
    this.getCategoryList();
  };

  onUpdate = (id, sort) => {
    console.log(sort);
    categoryService.updateCategory(id, {
      id: id,
      sort: sort,
    });
    toast.success(`Category sort updated Successfully`, {
      position: toast.POSITION.TOP_CENTER,
    });
    this.getCategoryList();
  };

  render() {
    let data =
      this.state.categoryList != null
        ? this.state.categoryList
            .sort((a, b) => a.createdAt > b.createdAt)
            .map((cat, i) => {
              return {
                index: i + 1,
                name: cat.name,
                ar_name: cat.ar_name,
                action: (
                  <>
                    <Input.Group compact>
                      <Input
                        style={{ width: "10%" }}
                        defaultValue={cat.sort}
                        onChange={(e) => this.onUpdate(cat.id, e.target.value)}
                      />
                    </Input.Group>
                    <Button
                      className="btn btn-danger text-white"
                      onClick={() => this.onButtonClick(cat.id)}
                    >
                      Delete
                    </Button>
                  </>
                ),
              };
            })
        : null;

    const columns = [
      {
        title: "#",
        dataIndex: "index",
        key: "index",
      },
      {
        title: "Category Name",
        dataIndex: "name",
        key: "name",
        ...this.getColumnSearchProps("name"),
      },
      {
        title: "Arabic Category Name",
        dataIndex: "ar_name",
        key: "ar_name",
        ...this.getColumnSearchProps("ar_name"),
      },
      {
        title: "Action",
        dataIndex: "action",
        key: "action",
      },
    ];
    return (
      <>
        <h5 className="m-0">Categories</h5>
        <Row form>
          <Col md="12" className="form-group  mt-4">
            <Table
              columns={columns}
              dataSource={data !== null ? data : null}
              className="p-0 m-0"
              pagination={{ pageSize: 5, position: ["bottomCenter"] }}
              style={{ textAlign: "center" }}
            />
          </Col>
        </Row>
      </>
    );
  }
}
